import type {DataLayout, GridSection, PlaceholderBlock} from 'analysis-tool/data-layout/DataLayoutTypes';

import {DEFAULT_LAYOUT_COLUMNS, DEFAULT_LAYOUT_ROWS, PLACEHOLDER_BLOCK} from './LayoutConstants';

type DefaultGridSection = Omit<GridSection, 'rows'> & {rows: Array<Array<PlaceholderBlock>>};

export interface DefaultLayoutConfig {
  name: DataLayout['name'];
  sections: Array<DefaultGridSection>;
  isLocked: boolean;
}

export const DEFAULT_LAYOUT_CONFIG: DefaultLayoutConfig = {
  name: '[New Layout]',
  isLocked: false,
  sections: [
    {
      type: 'GRID',
      title: null,
      gridMode: 'SEPARATED',
      rows: Array.from({length: DEFAULT_LAYOUT_ROWS}, () =>
        Array.from({length: DEFAULT_LAYOUT_COLUMNS}, () => PLACEHOLDER_BLOCK)
      ),
    },
  ],
};

/**
 * Returns true if the layout is locked (not user-editable). Defaults to true when
 * `isLocked` is not specified, so existing layouts without the field are treated as locked.
 */
export function isLockedLayout(layoutConfig: {isLocked: boolean | null}): boolean {
  return layoutConfig.isLocked ?? true;
}
